import { createFileRoute } from '@tanstack/react-router';
import EntryIndexPage from '@/features/resume-builder/entry/EntryIndexPage';

/** EU-762 — entrada da etapa: escolha da rota, ou "Currículo pronto!" quando já há geração. */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo/')({
  component: EntryIndexPage,
});
